<template>
  <section
    class="component-c70022cc"
    resmed-component-name="sleep_apnea_full_product_list_recently_viewed"
    v-if="items.length"
  >
    <div class="component" v-bind:class="{ 'is-active': init }">
      <div class="container mb-3">
        <h2 class="text-center">Recently viewed</h2>
      </div>

      <div style="overflow: hidden" class="swiper-wrapper">
        <div class="swiper container">
          <div class="row">
            <div
              class="col col-md-10 offset-md-1 col-lg-12 offset-lg-0"
              style="padding: 0"
            >
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    ['md', 'lg', 'xl'].includes($root.mode) && items.length > 4
                  "
                >
                  <a
                    ref="swiperButtonPrev"
                    href="#"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    ref="swiperButtonNext"
                    href="#"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="stage swiper-container"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    v-bind:class="{
                      '-justify-content-center': items.length < 4,
                    }"
                  >
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(item, index) in items"
                    >
                      <div
                        class="card"
                        v-bind:class="item.category"
                        v-bind:style="{
                          'border-top-color': colors[item.category],
                        }"
                      >
                        <div class="content">
                          <p class="category-name">{{ item.category }}</p>
                          <h3>{{ item.title }}</h3>
                          <ul>
                            <li v-for="item in item.description">
                              {{ item.entry }}
                            </li>
                          </ul>
                          <a
                            v-if="item.cta"
                            v-bind:href="item.cta.href"
                            v-bind:target="item.cta.target"
                            class="btn cta-plain text-red icon right-arrow"
                            >{{ item.cta.text }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && items.length > 1) ||
              ($root.mode === 'md' && items.length > 2) ||
              (['lg', 'xl'].includes($root.mode) && items.length > 4)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-c70022cc", // sleep_apnea_full_product_list_recently_viewed
  data() {
    return {
      slider: undefined,
      init: false,
      items: [],
      colors: [],
    };
  },
  mixins: [helper],
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
  methods: {
    swhCreate() {
      if (!this.$refs.swiperContainer) {
        return;
      }

      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
  created() {
    let items = JSON.parse(localStorage.getItem("recently-viewed")); // limit to 4 items for now
    if (items) {
      // this.items = items.slice(0, 4);
      this.items = items;
    }

    bus.$on("recently-viewed:init", (arg) => {
      this.colors = arg;
      this.init = true;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-c70022cc {
  padding: 6rem 0 5rem 0;
  background-color: #fff;

  .component {
    opacity: 0;

    &.is-active {
      animation: fade-in 2s ease;
      animation-fill-mode: forwards;
    }

    .stage {
      .items {
        display: flex;
        align-items: stretch;
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;

        &.-justify-content-center {
          @media (min-width: 992px) {
            justify-content: center;
          }
        }
      }

      .item {
        padding: 0 0.625rem;
        display: flex;
        flex-shrink: 0;
        align-items: stretch;
      }
    }

    .swiper {
      padding: 0 3.5rem;

      @media (min-width: 768px) {
        padding: 0;
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    .seek-wrapper {
      position: absolute;
      z-index: 1;

      width: 30%;
      bottom: -42px;
      left: 50%;
      transform: translateX(-50%);

      @media (min-width: 992px) {
        width: 20%;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        width: 100%;
        bottom: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      @media (min-width: 1306px) {
        width: 100%;
        bottom: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      a:nth-child(1) {
        float: left;
        transform: translateX(-3rem) scale(1.175);

        @media (min-width: 992px) {
          transform: translateX(-4rem) scale(1.4);
        }
      }

      a:nth-child(2) {
        float: right;
        transform: translateX(3rem) scale(1.175);

        @media (min-width: 992px) {
          transform: translateX(4rem) scale(1.4);
        }
      }
    }

    .-mode-xs,
    .-mode-sm {
      &.swiper-container {
        overflow: visible;
      }
    }

    .-mode-md,
    .-mode-lg,
    .-mode-xl {
      &.swiper-container {
        overflow: hidden;
      }
    }

    .swiper-container {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 100%;

      margin: 0 auto;
      padding: 1rem 0 0.5rem 0;

      @media (min-width: 768px) {
        padding: 1rem 0 2rem 0;
      }
    }
  }
}
</style>